import { render, staticRenderFns } from "./StudentDetailRow.vue?vue&type=template&id=5666b5c4&"
import script from "./StudentDetailRow.vue?vue&type=script&lang=ts&"
export * from "./StudentDetailRow.vue?vue&type=script&lang=ts&"
import style0 from "./StudentDetailRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports